import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export default function TextLink({ to, children, light = false }: { to: string; children: ReactNode; light?: boolean }) {
  return (
    <Link
      to={to}
      className={`group inline-flex items-center gap-2 text-[15px] font-medium border-b pb-1 whitespace-nowrap cursor-pointer transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-500 ${light ? 'border-background-50/40 text-background-50' : 'border-foreground-950/30 text-foreground-950 hover:border-foreground-950'}`}
    >
      {children}
      <span className="w-4 h-4 flex items-center justify-center transition-transform duration-200 group-hover:translate-x-1">
        <i className="ri-arrow-right-line" />
      </span>
    </Link>
  );
}